import React, { Fragment, useCallback } from 'react'

import styled from 'styled-components'

import { ProgressBar, StepError } from '..'
import { setMatchMakerQuestion } from '../../../../services/match-maker'
import { Column, Row } from '../../Grid'
import { Text } from '../../Text'

import { RangeSlider } from 'components/v2/RangeSlider'


const TherapyPriceStep = ({ state, dispatch, goToNextStep, goToPreviousStep, maxSteps }) => {
  const submitTherapyPriceStep = useCallback(async () => {
    dispatch({ type: 'set_status', payload: 'loading' })
    try {
      const { data } = await setMatchMakerQuestion({
        id_session: state.id_session,
        answers: [
          { question: state.questions[3].id, answer: state.form_values.budget[0] },
          { question: state.questions[4].id, answer: state.form_values.budget[1] }
        ]
      })
      goToNextStep(data)
    } catch {
      dispatch({ type: 'set_status', payload: 'error' })
    }
  }, [state.form_values.budget])

  if (state.status === 'error') {
    return (
      <StepError
        stepImage='/static/images/match-maker/04.png'
        submitStep={submitTherapyPriceStep}
      />
    )
  }

  return (
    <Fragment>
      <div className='step__illustration lg:hidden'>
        <img src='/static/images/match-maker/04.png' width='100%' />
      </div>
      <div className='step__question'>
        <p className='step__question__title mb-5'>Quanto pretende gastar com terapia?</p>
        <p className='step__question__description'>O valor mínimo da consulta é R$50</p>
        <div className='step__question__template mb-5'>
          <SliderContainer>
            <RangeSlider
              range
              min={50}
              max={350}
              value={state.form_values.budget}
              onChange={values =>
                dispatch({
                  type: 'set_budget',
                  payload: [values[0], values[1]]
                })
              }
              allowCross={false}
              pushable={8}
            />

            <Row className='justify-between w-full mt-2.5'>
              <Text>{`R$${state.form_values.budget[0]}`}</Text>
              <Text>{`R$${state.form_values.budget[1]}`}</Text>
            </Row>
          </SliderContainer>
        </div>
        <div className='step__question__info mt-5'>
          <div className='step__question__info__next-step-container'>
            <div className='step__question__info__next-step-container__navigation'>
              <button
                className='button-verm-leaked match-maker-button mr-3'
                onClick={goToPreviousStep}
              >
                Voltar
              </button>
              <button
                className='button-verm match-maker-button'
                onClick={submitTherapyPriceStep}
                id='step4-matchmaking'
              >
                Próximo
              </button>
            </div>
            {state.current_step > 0 && (
              <ProgressBar maxSteps={maxSteps} visualStep={state.visual_step} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const SliderContainer = styled(Column)`
  width: 375px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 375px) {
    width: 80%;
  }
`

export { TherapyPriceStep }
